
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from 'lucide-react';

const AdCTA: React.FC = () => {
  return (
    <div className="relative py-16 px-6 rounded-2xl overflow-hidden backdrop-blur-sm bg-gradient-to-r from-blue-50/80 to-indigo-50/80 dark:from-blue-900/20 dark:to-indigo-900/20 shadow-lg border border-white/20 dark:border-white/5 animate-fade-in-up opacity-0" style={{animationDelay: "200ms", animationFillMode: "forwards"}}>
      {/* Background patterns */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-100/30 via-transparent to-transparent dark:from-blue-500/5"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-indigo-100/30 via-transparent to-transparent dark:from-indigo-500/5"></div>
      
      <div className="relative z-10 text-center">
        <Sparkles className="h-12 w-12 text-heading-accent mx-auto mb-6 animate-float" />
        
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-gray-100 animate-fade-in-up opacity-0" style={{animationDelay: "400ms", animationFillMode: "forwards"}}>
          Let's Show You What AI Can Actually Do for Your Business
        </h2>
        
        <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-8 max-w-2xl mx-auto animate-fade-in-up opacity-0" style={{animationDelay: "600ms", animationFillMode: "forwards"}}>
          Tell us where you want results. We'll send back a focused plan—fast, free, and built to make sense on paper.
        </p>
        
        <Button 
          size="lg" 
          className="bg-heading-accent hover:bg-heading-accent/90 text-white group btn-hover-effect text-lg px-8 py-6 h-auto animate-fade-in-up opacity-0 transition-all duration-300"
          style={{animationDelay: "800ms", animationFillMode: "forwards"}}
          onClick={() => {
            const formSection = document.getElementById("lead-form");
            formSection?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          Get My Custom Plan
          <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
        </Button>
      </div>
    </div>
  );
};

export default AdCTA;
